import { Alert } from '@/shared/components/ui/alert/Alert';
import { LoadingSpinner } from '@/shared/components/ui/loadingspinner/LoadingSpinner';
import { DealerAssignmentsTable } from './DealerAssignmentsTable';
import { ProductTemplateSlots } from './ProductTemplateSlots';
import type { ProductDocumentsLayoutProps } from './productDocumentsView.types';

interface Props extends ProductDocumentsLayoutProps {
  status: 'ready' | 'loading' | 'error';
  errorMessage?: string;
  truncationNotice?: string;
}

export function ProductDocumentsView({ status, errorMessage, truncationNotice, ...layoutProps }: Props) {
  if (status === 'loading') {
    return (
      <div className="flex justify-center py-12">
        <LoadingSpinner />
      </div>
    );
  }
  if (status === 'error') {
    return <Alert variant="error">{errorMessage ?? 'Template assignments could not be loaded.'}</Alert>;
  }
  return (
    <div className="space-y-6">
      {truncationNotice && <Alert variant="warning" role="status">{truncationNotice}</Alert>}
      <ProductTemplateSlots {...layoutProps} />
      <DealerAssignmentsTable {...layoutProps} />
    </div>
  );
}
